export default {
  data: () => ({
    // Keep track of timeout
    utils_$filterTimeout: 0,

    // Mantain an association between key and callback
    utils_$keyCallbacks: undefined,
  }),

  methods: {
    // Delay function call
    utils_delayExecute: function(callback, timeout = 300) {
      // Reset current timeout
      if (this.utils_$filterTimeout) {
        clearTimeout(this.utils_$filterTimeout);
        this.utils_$filterTimeout = 0;
      }

      // Create a delayed function call
      this.utils_$filterTimeout = setTimeout(() => {
        this.utils_$filterTimeout = 0;
        callback();
      }, timeout);
    },

    // Set focus on the given input text
    utils_focusInput: function(element, delay = 0) {
      if (delay > 0) {
        setTimeout(() => { this.utils_focusInput(element); }, delay);
      } else {
        // If a name is given, search it inside the references
        if (typeof element === 'string')
          element = this.$refs[element];

        // First search for input elements ...
        let collection = element.$el.getElementsByTagName('input');

        // ... then for textarea
        if (collection.length === 0)
          collection = element.$el.getElementsByTagName('textarea');

        if (HTMLCollection.prototype.isPrototypeOf(collection) && collection.length)
          collection[0].focus();
        else if (collection)
          collection.focus();
      }
    },

    // Remove key callback association
    utils_removeShortcut: function(key) {
      if (typeof key === 'string' && key.length > 0 && this.utils_$keyCallbacks) {
        key = key.charAt(0);
        key in this.utils_$keyCallbacks && delete this.utils_$keyCallbacks[key];
      }
    },

    // Set key and callbacks
    utils_addShortcut: function(key, callback) {
      if (typeof key === 'string' && key.length > 0 && typeof callback == 'function') {
        if (this.utils_$keyCallbacks === undefined) {
          const self = this;

          this.utils_$keyCallbacks = {};

          // Create the callback function
          window.addEventListener('keydown', function (event) {
            if ((event.metaKey || event.ctrlKey) && event.key in self.utils_$keyCallbacks) {
              event.preventDefault();
              self.utils_$keyCallbacks[event.key]();
            }
          });
        }

        // Add the shorcut to the list
        this.utils_$keyCallbacks[key.charAt(0)] = callback;
      }
    }
  }
}
